import { forwardRef } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import NRSecondaryLinkStyles from './NRSecondaryLink.styles';
import clsx from 'clsx';

const useStyles = makeStyles(NRSecondaryLinkStyles);

const NRSecondaryLink = forwardRef((props, ref) => {
  const classes = useStyles();
  const { value, handleOnClick, openNull = true, ...rest } = props;

  return (
    <span
      ref={ref}
      {...rest}
      onClick={() => (openNull ? handleOnClick() : value > 0 && handleOnClick())}
      className={clsx(classes.styleBase, { [classes.activeLink]: openNull || value > 0 })}
    >
      {value}
    </span>
  );
});
export default NRSecondaryLink;
